/**
 * Custom Lightbox Implementation
 * Initialize lightbox for custom gallery markup with data-wp-lightbox attribute
 */

document.addEventListener('DOMContentLoaded', function() {

	const galleryLinks = document.querySelectorAll('a[data-wp-lightbox]');

	if (galleryLinks.length === 0) {
		return;
	}

	// Attach click handler directly to each link
	galleryLinks.forEach((link, idx) => {
		link.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			const lightboxGroup = this.getAttribute('data-wp-lightbox');
			const allLinks = Array.from(document.querySelectorAll(`a[data-wp-lightbox="${lightboxGroup}"]`));
			const currentIndex = allLinks.indexOf(this);


			openLightbox(allLinks, currentIndex);
		});
	});

	/**
	 * Open lightbox with gallery images
	 * @param {Array} allLinks - All links in the gallery group
	 * @param {Number} startIndex - Index of the clicked image
	 */
	function openLightbox(allLinks, startIndex) {
		let currentImageIndex = startIndex;

		const lightboxHTML = `
			<div class="maze-lightbox" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.95); z-index: 99999; display: flex; align-items: center; justify-content: center;">
				<button class="maze-lightbox__close" aria-label="Fermer"></button>
				<button class="maze-lightbox__prev" aria-label="Image précédente"></button>
				<div class="maze-lightbox__container">
					<img class="maze-lightbox__image" src="" alt="">
				</div>
				<button class="maze-lightbox__next" aria-label="Image suivante"></button>
				<div class="maze-lightbox__counter"></div>
			</div>
		`;

		document.body.insertAdjacentHTML('beforeend', lightboxHTML);

		const lightbox = document.querySelector('.maze-lightbox');
		const lightboxImage = document.querySelector('.maze-lightbox__image');
		const closeBtn = document.querySelector('.maze-lightbox__close');
		const prevBtn = document.querySelector('.maze-lightbox__prev');
		const nextBtn = document.querySelector('.maze-lightbox__next');
		const counter = document.querySelector('.maze-lightbox__counter');

		/**
		 * Display image at specific index
		 * @param {Number} index - Image index
		 */
		function showImage(index) {
			currentImageIndex = ((index % allLinks.length) + allLinks.length) % allLinks.length;
			const link = allLinks[currentImageIndex];
			const href = link.getAttribute('href');
			const img = link.querySelector('img');

			lightboxImage.src = href;
			lightboxImage.alt = img?.getAttribute('alt') || '';
			counter.textContent = `${currentImageIndex + 1} / ${allLinks.length}`;
		}

		showImage(startIndex);

		/**
		 * Cleanup function - remove lightbox and detach all listeners
		 */
		const cleanup = function() {
			if (lightbox && lightbox.parentElement) {
				lightbox.remove();
			}
			document.removeEventListener('keydown', keyHandler);
			if (closeBtn) closeBtn.removeEventListener('click', onCloseClick);
			if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
			if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
		};

		/**
		 * Keyboard navigation handler
		 */
		const keyHandler = function(e) {
			if (!lightbox || !lightbox.parentElement) {
				document.removeEventListener('keydown', keyHandler);
				return;
			}

			if (e.key === 'Escape') {
				cleanup();
			} else if (e.key === 'ArrowLeft') {
				showImage(currentImageIndex - 1);
			} else if (e.key === 'ArrowRight') {
				showImage(currentImageIndex + 1);
			}
		};

		/**
		 * Close button click handler
		 */
		const onCloseClick = function(e) {
			e.preventDefault();
			e.stopPropagation();
			cleanup();
		};

		/**
		 * Previous button click handler
		 */
		const onPrevClick = function(e) {
			e.preventDefault();
			e.stopPropagation();
			showImage(currentImageIndex - 1);
		};

		/**
		 * Next button click handler
		 */
		const onNextClick = function(e) {
			e.preventDefault();
			e.stopPropagation();
			showImage(currentImageIndex + 1);
		};

		// Attach event listeners
		closeBtn?.addEventListener('click', onCloseClick);
		prevBtn?.addEventListener('click', onPrevClick);
		nextBtn?.addEventListener('click', onNextClick);
		lightbox?.addEventListener('click', function(e) {
			if (e.target === lightbox) {
				cleanup();
			}
		});
		document.addEventListener('keydown', keyHandler);
	}
});

